import { DocumentSource, SourceToken } from "./marvinSources";

/** The server still projects the Marvin default scope under this legacy settings key
 *  (native clients read it from the project settings); the page's own copy comes from
 *  `GET /project-settings/marvin`. The setting itself is `marvin.default_scope`. */
export const MARVIN_DEFAULT_SCOPE_KEY = "features.marvin.default_scope";
export const NATIVE_SCOPED_CREATE_FLAG_KEY = "features.native.marvin_scoped_create.enabled";
/** The scope tokens the setting accepts, in display order, plus the open `folder:` family. */
export const DEFAULT_SCOPE_CHOICES: string[] = [
    "contract-docs",
    "contract-docs:drawings",
    "contract-docs:specs",
    "contract-docs:rfis",
    "contract-docs:schedules",
    "contract-docs:supplemental",
    "category:documents",
    "submittals",
    "models",
    "codes",
    "ifoa",
    "primecontract",
    "contracts",
];
const OPEN_PREFIXES: string[] = ["folder:"];

function matchesOpenPrefix(value: string): boolean {
    return OPEN_PREFIXES.some((prefix) => value.startsWith(prefix) && value.length > prefix.length);
}

export function liveDefaultScopes(
    values: SourceToken[],
    folderOptions: readonly { token: SourceToken }[],
): SourceToken[] {
    const liveFolders = new Set(folderOptions.map((option) => option.token));
    const live = values.filter((value) => !matchesOpenPrefix(value) || liveFolders.has(value));
    return live.length > 0 ? live : [DocumentSource.ContractDocs];
}

export function resolveMarvinDefaultScopes(raw: unknown): SourceToken[] {
    const entries = Array.isArray(raw) ? raw : typeof raw === "string" ? [raw] : [];
    const stored = entries.filter((value): value is string => typeof value === "string");
    const storedSet = new Set(stored);
    const resolved = DEFAULT_SCOPE_CHOICES.filter((value) => storedSet.has(value)) as SourceToken[];
    for (const value of stored) {
        if (matchesOpenPrefix(value) && !resolved.includes(value as SourceToken)) {
            resolved.push(value as SourceToken);
        }
    }
    return resolved.length > 0 ? resolved : [DocumentSource.ContractDocs];
}
